
import { defineComponent, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "PrintingCompleted",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const openPrintingHelp = () => {
      store.dispatch(ActionTypes.SET_MODAL, "printingHelp");
    };

    return { closeModal, bounceTransition, fadeTransition, openPrintingHelp };
  },
});
